<div class="filter-toolbar">
    <form [formGroup]="filterForms" (ngSubmit)="checkAndCallMethods()">
        <div class="filter-container">
            <!-- Filter dropdown -->
            @if (localTableFilters) {
            <mat-form-field subscriptSizing="dynamic" class="filter">
                <mat-label>Filter</mat-label>
                <mat-select formControlName="tableFilter" (selectionChange)="changeValue($event.value)">
                    @for (filter of localTableFilters; track filter) {
                    <mat-option [value]="filter">
                        {{filter.displayName}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }

            @if (filterForms.get('tableFilter')?.value) {
            <mat-form-field subscriptSizing="dynamic" class="filter">
                <mat-label>{{filterForms.value.tableFilter.displayName || ''}}</mat-label>

                @if (filterForms.value.tableFilter.displayName === 'Work Order Type') {
                <mat-select formControlName="value">
                    @for (workOrder of workOrders; track workOrder) {
                    @if (us == true || asia == true) {
                    <mat-option [value]="workOrder">
                        {{workOrder}}
                    </mat-option>
                    }
                    }
                    @for (workOrder of workOrdersUk; track workOrder) {
                    @if (europe == true) {
                    <mat-option [value]="workOrder">
                        {{workOrder}}
                    </mat-option>
                    }
                    }
                </mat-select>
                } @else {
                <!-- <ng-container mat-label></ng-container> -->
                @if (!isArray() && filterForms.value.tableFilter.displayName !== 'Mapped To' &&
                filterForms.value.tableFilter.displayName !== 'Work Order Type') {
                <input matInput placeholder="{{filterForms.value.tableFilter.displayName || ''}}"
                    formControlName="value">
                }
                @if (!filterForms.value.tableFilter) {
                <input matInput style="display: none;" formControlName="value">
                }
                @if (!filterForms.value.tableFilter) {
                <input matInput [disabled]="true" [value]="filterForms.value.value">
                }
                }

                @if (filterForms.value.tableFilter.displayName === 'Mapped To') {
                <mat-select formControlName="value">
                    @for (mapped of mappedTo; track mapped) {
                    <mat-option [value]="mapped">
                        {{mapped}}
                    </mat-option>
                    }
                </mat-select>
                }
            </mat-form-field>
            }

            <div class="buttons">
                <button mat-flat-button color="primary" class="button" type="submit" [disabled]="isFilterSet()"
                    (click)="isAddFilterCliecked()">Add</button>
                <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isAnyFilterSet()"
                    (click)="isSearchClicked()">Search</button>
                <button mat-stroked-button class="button" [disabled]="!isAnyFilterSet()"
                    (click)="reset()">Reset</button>
            </div>
        </div>

        @if (filterAdded) {
        <div class="chips">
            <mat-chip-set aria-label="Filter selection" class="example-chip-list">
                @for (filters of filterArray; track filters) {
                <mat-chip (removed)="remove(filters.value)">
                    {{filters.dispalyName}} - {{filters.value}}
                    @if (removable) {
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                    }
                </mat-chip>
                }
            </mat-chip-set>
        </div>
        }
    </form>
</div>
@if (isLoadingResults) {
<div class="loading-shade">
    <mat-spinner></mat-spinner>
</div>
}